<button
  type="button"
  class="btn txt-lg button-shadow tw-mx-1 btn-hover-rise"
  [themeColor]="btnColor"
  [matTooltip]="title | translate"
  mat-ripple
  (click)="openPage(name)"
>
  <i class="tw-mx-1 mdi" [ngClass]="icon" [class]="iconSize"></i>
</button>
